export function ThicknessAdjuster(thickness) {
  return (thickness % 2) * 0.5;
}
